/**
 * Shared constants + tiny presentational pieces for the Employees page.
 * Extracted from Employees.jsx so the main file stays focused on state + dialogs.
 */

export const initialForm = {
  email: '', password: '', name: '', role: 'employee',
  title: '', grade: '', department: '', phone: '',
  reporting_manager_id: '', annual_ctc: '',
  employment_type: 'full_time', salary_period: 'yearly', pay_amount: '',
  branch_id: '',
  // Offer-letter terms — used in the public offer page + offer email
  casual_leaves: 10, sick_leaves: 5, weekly_hours: 40, probation_months: 3,
  // Rich-text sections — auto-prefilled from /offer-templates when the dialog opens
  roles_responsibilities: '', terms_conditions: '',
};

export const initialManualForm = () => ({
  name: '', work_email: '', password: '', personal_email: '',
  role: 'employee', title: '', grade: '', department: '', phone: '',
  reporting_manager_id: '', annual_ctc: '', joined_at: new Date().toISOString().slice(0, 10),
  employment_type: 'full_time', salary_period: 'yearly', pay_amount: '',
  branch_id: '',
});

export const EMP_TYPES = [
  { v: 'full_time', label: 'Full-time' },
  { v: 'contract', label: 'Contract' },
  { v: 'internship', label: 'Internship' },
  { v: 'freelancer', label: 'Freelancer' },
  { v: 'volunteer', label: 'Volunteer (unpaid)' },
];

export const PERIODS = [
  { v: 'yearly', label: 'Per year', helper: 'Annual CTC' },
  { v: 'monthly', label: 'Per month', helper: 'Monthly salary' },
  { v: 'hourly', label: 'Per hour', helper: 'Hourly rate · annualised at 40h × 52w' },
];

export const grades = [
  { v: 'L1', label: 'L1 · Junior' },
  { v: 'L2', label: 'L2 · Associate' },
  { v: 'L3', label: 'L3 · Mid' },
  { v: 'L4', label: 'L4 · Senior' },
  { v: 'L5', label: 'L5 · Lead/Principal' },
];

export const STATUS_OPTIONS = [
  { v: 'all',         label: 'Any status',  dot: 'bg-slate-300' },
  { v: 'active',      label: 'Active',      dot: 'bg-emerald-500' },
  { v: 'onboarding',  label: 'Onboarding',  dot: 'bg-blue-500' },
  { v: 'resigning',   label: 'Resigning',   dot: 'bg-amber-500' },
  { v: 'terminated',  label: 'Terminated',  dot: 'bg-red-500' },
  { v: 'rejected',    label: 'Rejected',    dot: 'bg-slate-500' },
];

export function inr(n) {
  if (n == null) return '—';
  return `₹${Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
}

export function StatusPill({ status }) {
  const styles = {
    verified: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    offer_sent: 'bg-slate-100 text-slate-600 border-slate-200',
    documents_pending: 'bg-blue-50 text-blue-700 border-blue-200',
    bgc_review: 'bg-amber-50 text-amber-700 border-amber-200',
    bgc_cleared: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    rejected: 'bg-red-50 text-red-700 border-red-200',
  };
  const labels = {
    verified: 'Active', offer_sent: 'Offer sent',
    documents_pending: 'Uploading docs', bgc_review: 'BGC review',
    bgc_cleared: 'BGC cleared', rejected: 'Rejected',
  };
  return (
    <span className={`text-[10px] uppercase tracking-wider font-bold px-2 py-0.5 rounded-full border ${styles[status] || styles.verified}`}>
      {labels[status] || status}
    </span>
  );
}
